import { Button } from '../components/Button';
import { HowToSteps } from '../components/HowToSteps';
import { Icon } from '../components/Icon';
import { Modal } from '../components/Modal';
import type { AnyPuzzleMode } from '../engine/types';

interface HowToPlayModalProps {
  mode: AnyPuzzleMode;
  open: boolean;
  onClose: () => void;
  /** When provided, the modal shows a "Play <mode>" button so you can go
      straight from the rules into a game (used from the guide; omitted in-game,
      where you're already playing this mode). */
  onPlay?: () => void;
}

export function HowToPlayModal({ mode, open, onClose, onPlay }: HowToPlayModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        <span className="cv-row" style={{ gap: 'var(--space-xs)' }}>
          <Icon name={mode.glyph} size={24} />
          How to play {mode.name}
        </span>
      }
    >
      <p className="cv-muted" style={{ marginBottom: 'var(--space-lg)' }}>
        {mode.description}
      </p>
      <HowToSteps steps={mode.howToPlay} />
      {onPlay ? (
        <div className="cv-modal__footer">
          <Button variant="primary" block iconLeft="play" onClick={onPlay}>
            Play {mode.name}
          </Button>
        </div>
      ) : null}
    </Modal>
  );
}
